<script>
    import { Button } from '$lib/components/UI'
    import Sucursal from './Sucursal.svelte'
    import { createEventDispatcher } from 'svelte'
    import ModalX from '$lib/components/UI/ModalX.svelte'
    export let title = 'Agregar una sucursal'
    export let subtitle = ''
    export let data = {}
    export let valid = false
    // export let editable = true
    export let disabled = false
    const dispatch = createEventDispatcher()
    function onClose() {
        dispatch('close')
    }
    function onSave() {
        dispatch('save', { data })
    }
</script>

<!-- ="A continucion ubique su sucursal en el mapa, luego complete y verifique sus datos" -->
<ModalX
    on:clickout={onClose}
    {title}
    {subtitle}
    style="width: 50%; min-width: 617px; max-height: calc(100% - 140px); height: auto;margin: 75px 0 0 0"
    on:close={onClose}
>
    <Sucursal
        editable={!disabled}
        bind:data
        bind:valid
        style="padding: 25px 0"
    />
    <svelte:fragment slot="buttonSet">
        <!-- <Button on:click={() => {editable = !editable}}>c</Button> -->
        {#if $$slots.buttonSet}
            <slot name="buttonSet" />
        {:else}
            <Button disabled={!valid} label="Guardar" on:click={onSave} />
        {/if}
    </svelte:fragment>
</ModalX>
